<div class="login-page">
  <div class="login-shell">
    <section class="login-brand-panel">
      <div class="brand-mark">
        <img
          class="brand-mark__logo"
          src="assets/img/logo.png"
          alt="RB Clínica Dental"
        />
        <span class="brand-mark__subtitle">Plataforma interna profesional</span>
      </div>

      <div class="brand-content">
        <span class="eyebrow">Plataforma Dental RB</span>
        <p class="brand-description">
          Accede a agenda, recalls, encuestas, reseñas y gestión interna desde
          una interfaz unificada pensada para trabajo diario real.
        </p>

        <div class="brand-highlights">
          <article class="highlight-card">
            <span class="highlight-card__label">Seguimiento</span>
            <strong>Agenda, recalls y cumpleaños</strong>
            <p>Todo el circuito operativo en una sola herramienta.</p>
          </article>

          <article class="highlight-card">
            <span class="highlight-card__label">Control</span>
            <strong>Reseñas, encuestas y equipo</strong>
            <p>Visibilidad diaria para coordinación y dirección.</p>
          </article>
        </div>
      </div>
    </section>

    <section class="login-card">
      <div class="login-card__header">
        <span class="eyebrow eyebrow--form">Acceso seguro</span>
        <h2>Inicia sesión</h2>
        <p class="subtitle">
          Introduce tus credenciales para continuar en la plataforma.
        </p>
      </div>

      <form class="login-form" (ngSubmit)="submit()">
        <div class="form-group">
          <label for="username">Usuario</label>
          <div class="input-shell">
            <span class="input-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path
                  d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-4.418 0-8 2.239-8 5v1h16v-1c0-2.761-3.582-5-8-5Z"
                />
              </svg>
            </span>
            <input
              id="username"
              name="username"
              type="text"
              [(ngModel)]="username"
              autocomplete="username"
              required
            />
          </div>
        </div>

        <div class="form-group">
          <label for="password">Contraseña</label>
          <div class="input-shell">
            <span class="input-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path
                  d="M17 10V8a5 5 0 0 0-10 0v2H5v10h14V10Zm-8 0V8a3 3 0 0 1 6 0v2Zm3 7a2 2 0 0 1-1-3.732V12h2v1.268A2 2 0 0 1 12 17Z"
                />
              </svg>
            </span>
            <input
              id="password"
              name="password"
              type="password"
              [(ngModel)]="password"
              autocomplete="current-password"
              required
            />
          </div>
        </div>

        <button class="submit-button" type="submit" [disabled]="loading">
          @if (loading) {
            Entrando...
          }
          @if (!loading) {
            Entrar en la plataforma
          }
        </button>
      </form>

      <div class="login-card__footer">
        <span class="footer-pill">Entorno interno</span>
        <span class="footer-copy"
          >Dental RB · Acceso restringido a personal autorizado</span
        >
      </div>
    </section>
  </div>
</div>
